<script>
  import cancelImage from "./assets/undraw_cancel_u1it.png";
  import redirectImage from "./assets/undraw_online_transactions_02ka.png";

  const whitelists = ["opencerts.io", "tradetrust.io", "gov.sg", "accredify.io"];
  const countdownFrom = 3;

  const getDomain = (hostname) => hostname.split(".").slice(-2).join(".");

  // The action is attacker-supplied, so treat anything unparseable as "no platform specified"
  // rather than letting it throw and leave a blank page behind.
  const parseAction = () => {
    try {
      return JSON.parse(window.decodeURI(new URLSearchParams(location.search).get("q")));
    } catch {
      return null;
    }
  };

  // use URL to ignore protocols, path, etc... a redirect we cannot parse is never authorized
  const isAuthorized = (redirect) => {
    try {
      return whitelists.includes(getDomain(new URL(redirect).hostname));
    } catch {
      return false;
    }
  };

  const redirect = parseAction()?.payload?.redirect;
  const valid = Boolean(redirect) && isAuthorized(redirect);

  let timer = $state(countdownFrom);

  $effect(() => {
    if (!valid) return;

    const interval = setInterval(() => {
      timer -= 1;
      if (timer === 0) {
        clearInterval(interval);
        window.location.href = `${redirect}${location.search}${window.location.hash}`;
      }
    }, 1000);

    return () => clearInterval(interval);
  });

  /**
   *
  https://action.openattestation.com/?q=%7B%22type%22:%22DOCUMENT%22,%22payload%22:%7B%22uri%22:%22https://api.myjson.com/bins/1a9acm%22,%22key%22:%221b8c334a38f9ff96108303a4ba0cc592f1559eb24f5b48b70c9300c60a34d5e9%22,%22permittedAction%22:%5B%22STORE%22%5D,%22redirect%22:%22https://dev.opencerts.io%22%7D%7D
   */
</script>

<main>
  {#if valid}
    <div class="container">
      <div class="text">
        Redirecting to
        <span class="success">{redirect}</span>
        in {timer}
      </div>
      <div class="img-container">
        <img src={redirectImage} class="icon" alt="redirect" />
      </div>
    </div>
  {:else}
    <div class="container">
      <div class="text">
        {#if redirect}
          <span class="error">{redirect}</span>
          <br />
          is not an authorized platform.
        {:else}
          <span class="error">No platform specified</span>
        {/if}
      </div>
      <div class="img-container">
        <img src={cancelImage} class="icon" alt="redirect" />
      </div>
    </div>
  {/if}
</main>

<style>
  .container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .container > div {
    max-width: 90%;
  }
  .img-container {
    text-align: center;
  }
  .icon {
    width: 50vw;
    min-width: 200px;
    max-width: 600px;
  }
  .text {
    text-align: center;
    font-size: 1.5rem;
  }
  .error {
    color: #ff6584;
    font-weight: 500;
  }
  .success {
    color: #6c63ff;
    font-weight: 500;
  }
</style>
